import * as React from "react";
import BlockCard from "../atoms/BlockCard";
import { TemplateBlock } from "../../types/blockTypes";

interface BlocksListProps {
  blocks: TemplateBlock[];
  placeholderCount: number;
  currentPlaceholderIndex: number;
  onInsertAtCursor: (block: TemplateBlock) => Promise<void>;
  onInsertAtPlaceholder: (block: TemplateBlock, placeholderIndex: number) => Promise<void>;
  onBlockPreview?: (block: TemplateBlock) => void;
}

const BlocksList: React.FC<BlocksListProps> = ({ 
  blocks, 
  placeholderCount,
  currentPlaceholderIndex,
  onInsertAtCursor,
  onInsertAtPlaceholder,
  onBlockPreview 
}) => {
  return (
    <div style={{
      backgroundColor: 'transparent',
      display: 'flex',
      flexDirection: 'column',
      gap: '0'
    }}>
      {blocks.map((block) => (
        <BlockCard 
          key={block.id}
          block={block}
          placeholderCount={placeholderCount}
          currentPlaceholderIndex={currentPlaceholderIndex}
          onInsertAtCursor={onInsertAtCursor}
          onInsertAtPlaceholder={onInsertAtPlaceholder}
          onPreview={onBlockPreview}
        />
      ))}
    </div>
  );
};

export default BlocksList;

